<template>
  <Modal @close="close">
    <div slot="modal-header">
      {{ $t('general.add_new_address') }}
    </div>

    <el-form class="d-flex flex-column justify-content-center align-items-center container">
      <label class="mt-2 w-100">
        <b class="mr-3">{{ $t('general.contact_person') }}</b>
        <el-input v-model="contactPerson" />
      </label>
      <label class="mt-2 w-100">
        <b class="mr-3">{{ $t('general.company') }}</b>
        <el-input v-model="company" />
      </label>
      <label class="mt-2 w-100">
        <b class="mr-3">{{ $t('general.street_and_housenumber') }}</b>
        <el-input v-model="street" />
      </label>
      <label class="mt-2 w-100">
        <b class="mr-3">{{ $t('general.street_additional') }}</b>
        <el-input v-model="streetAdditonal" />
      </label>
      <label class="mt-2 w-100">
        <b class="mr-3">{{ $t('general.zip_code') }}</b>
        <el-input v-model="zipCode" />
      </label>
      <label class="mt-2 w-100">
        <b class="mr-3">{{ $t('general.city') }}</b>
        <el-input v-model="city" />
      </label>
      <label class="mt-2 w-100">
        <b class="mr-3">{{ $t('general.country') }}</b>
        <el-select v-model="country" class="w-100 mr-3 d-block" name="country" filterable automatic-dropdown>
          <el-option v-for="c in COUNTRIES" :key="c.code" :label="c.name" :value="c.code" />
        </el-select>
      </label>
    </el-form>
    <div slot="modal-footer">
      <el-button @click="onAddAddress">
        {{ $t('general.add') }}
      </el-button>
    </div>
  </Modal>
</template>

<script>
import Modal from '../atoms/Modal';
import { mapActions, mapGetters } from 'vuex';
import StoreModules from '../../store/store-modules';
import COUNTRIES from '../../config/countries';
export default {
  name: 'AddDeliveryAddressModal',
  components: { Modal },
  props: {},
  mounted() {},
  destroyed() {},
  data() {
    return {
      COUNTRIES,
      contactPerson: '',
      company: '',
      street: '',
      streetAdditonal: '',
      zipCode: '',
      city: '',
      country: '',
    };
  },
  computed: {},
  methods: {
    ...mapActions(StoreModules.CART, ['addToCart']),
    ...mapActions(StoreModules.DELIVERY_ADDRESSES, ['loadAddresses']),
    close() {
      this.$emit('close');
    },
    async onAddAddress() {
      if (!this.validateInputs()) return;

      let obj = new this.$parse.Object('DeliveryAddress');
      obj.set('contactPerson', this.contactPerson);
      obj.set('company', this.company);
      obj.set('street', this.street);
      obj.set('streetAdditonal', this.streetAdditonal);
      obj.set('zipCode', this.zipCode);
      obj.set('city', this.city);
      obj.set('country', this.country);
      obj.set('user', this.$parse.User.current());

      let acl = new this.$parse.ACL(this.$parse.User.current());
      obj.setACL(acl);

      await obj.save();
      await this.loadAddresses(true);
      this.$message.success(this.$t('general.address_added'));
      this.close();
    },
    validateInputs() {
      if (!this.contactPerson) {
        this.$message.info(this.$t('general.add_contact_person'));
        return false;
      }

      if (!this.company) {
        this.$message.info(this.$t('general.add_company'));
        return false;
      }

      if (!this.street) {
        this.$message.info(this.$t('general.add_streetname'));
        return false;
      }

      if (!this.zipCode) {
        this.$message.info(this.$t('general.add_postcode'));
        return false;
      }

      if (!this.city) {
        this.$message.info(this.$t('general.add_city'));
        return false;
      }

      if (!this.country) {
        this.$message.info(this.$t('general.add_country'));
        return false;
      }

      return true;
    },
  },
};
</script>

<style scoped></style>
